<template>
  <div class="docs" :id="toSlug(data.name)">
    <div class="docs__description">
      <h1>{{data.name}}</h1>
      <p v-html="data.description"></p>
    </div>
    <div class="docs__image">
      <img :src="'/images/' + data.image"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Docs',
  props: ['data'],
  mounted(){
    console.log(this.data)
  },
  methods:{
    toSlug(string){
      return string.replaceAll(' ', '-');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .docs {
    width: calc(100% - 300px);
    margin-left: 300px;
    height: 50%;
    display: flex;
    background: #FBCDB3;
    border-bottom: 4px solid #f3f3f3;

    @media(max-width:1200px){
      flex-direction: column-reverse;
      height: auto;
    }

    @media(max-width:600px){
      width: 100%;
      margin: 0;
    }


    &__description {
      width: 50%;
      padding: 3rem;
      display: flex;
      flex-direction: column;
      justify-content: center;

      @media(max-width:1200px){
        width: 100%;
        padding-bottom: 12rem;
      }

      h1 {
        color: #222;
        font-size: 4.4rem;
        font-weight: 100;
      }

      p {
        font-size: 1.4rem;
        line-height: 1.5;
      }

    }

    &__image {
      width: 50%;

      @media(max-width:1200px){
        width: 100%;
        overflow: hidden;
        min-height: 400px;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

    }

  }
</style>
